<script setup lang="ts">
  import { ref, computed } from "vue";
  import { Text, Button, IconPlus, IconMinus } from "@ui-kit";

  const { count = 0 } = defineProps<{ count: number }>();
  const emit = defineEmits<{ (e: "change", count: number): void }>();

  const counterRef = ref<HTMLDivElement>(null);
  const active = computed(() => count > 0);

  const handlePlus = () => {
    emit("change", count + 1);
  };
  const handleMinus = () => {
    emit("change", count - 1);
  };
</script>

<template>
  <div ref="counterRef" :class="['counter-with-button', { 'active': active }]" data-testid="counter-with-button">
    <Button
      size="s"
      variant="secondary"
      :disabled="count === 0"
      :icon-before="IconMinus"
      :as-square="true"
      @click="handleMinus"
      data-testid="counter-minus-btn"
    />
    <Text :color="active ? 'white' : 'primary'">{{ count }}</Text>
    <Button size="s" variant="secondary" :icon-before="IconPlus" :as-square="true" @click="handlePlus" data-testid="counter-plus-btn" />
  </div>
</template>

<style scoped>
  .counter-with-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 8px;
    background-color: var(--sf-base-background-primary);

    &.active {
      background-color: var(--sf-base-background-black);
    }

    & span {
      flex: 1;
    }
  }
</style>
